import * as React from 'react';
import Helmet from 'react-helmet';
import { PageDescription } from './PageDescription';
import { FacebookMeta } from './FacebookMeta';
import { OpenGraph } from './OpenGraph';
import { TwitterShare } from './TwitterShare';
import { GoogleNewsSchema } from './GoogleNewsSchema';
import { PageImage, createImageAttributes } from './metaTags.utils';
import { RobotsMeta } from './RobotsMeta';

interface PostMetaHeaderTagsProps {
  canonicalUrl: string;
  favicon: string;
  description: string;
  facebookAppId: string | null;
  facebookPageId: string | null;
  title: string;
  twitterAccount: string | null;
  siteName: string;
  pageImage: PageImage;
  logoUrl: string;
  authors: { name: string }[];
  createdAt: string;
  updatedAt: string;
  noIndex: boolean;
  ampURL: string | null;
  removeFromTaboola: boolean;
}

export const RemoveFromTaboolaMeta: React.FunctionComponent = () => (
  <Helmet>
    <meta name="can-recommend" content="false" />
  </Helmet>
);

export const PostMetaHeaderTags: React.FunctionComponent<PostMetaHeaderTagsProps> = ({ canonicalUrl, favicon, description, facebookAppId, facebookPageId, title, twitterAccount, siteName, pageImage, logoUrl, authors, createdAt, updatedAt, noIndex, ampURL, removeFromTaboola }) => {
  const { imageHeight, imageUrl, imageWidth } = createImageAttributes(pageImage);
  return (
    <React.Fragment>
      <PageDescription pageUrl={canonicalUrl} favicon={favicon} description={description} title={title} ampURL={ampURL} />
      <FacebookMeta appId={facebookAppId} pageId={facebookPageId} />
      <OpenGraph pageUrl={canonicalUrl} image={imageUrl} title={title} siteName={siteName} imageHeight={imageHeight} imageWidth={`${imageWidth}`} />
      <TwitterShare title={title} description={description} account={twitterAccount} image={imageUrl} pageUrl={canonicalUrl} />
      <GoogleNewsSchema canonical={canonicalUrl} title={title} image={imageUrl} datePublished={createdAt} dateModified={updatedAt} authors={authors} publisherName={siteName} logoUrl={logoUrl} />
      <RobotsMeta noIndex={noIndex} />
      {removeFromTaboola ? <RemoveFromTaboolaMeta /> : null}
    </React.Fragment>
  );
};
